export default __webpack_public_path__ + "static/media/error.534c5398.svg";